import { fetchSocialLogin } from '@/redux/thunk/authThunk';
import AppleSignin from 'react-apple-signin-auth';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@/redux/store';
import { toast } from 'react-toastify';
import { login } from '@/redux/slices/authSlice';
import { loginResponse } from '@/helpers/types/authTypes';
import { AppleLogo } from '@/components/icons/apple-logo';

const AppleAuthComponent = ({
  supplier_referral,
}: {
  supplier_referral: string | null;
}) => {
  const dispatch = useDispatch<AppDispatch>();
  return (
    <div className="mt-1 w-full active:scale-95 transition-transform duration-100">
      <AppleSignin
        uiType="light"
        authOptions={{
          clientId: process.env.NEXT_PUBLIC_APPLE_CLIENT_ID || '',
          scope: 'email name',
          redirectURI: process.env.NEXT_PUBLIC_APPLE_REDIRECT_URI || '',
          state: 'state',
          nonce: 'nonce',
          usePopup: true,
        }}
        onSuccess={async (response: any) => {
          console.log(response);
          try {
            const data = await dispatch(
              fetchSocialLogin({
                provider: 'apple',
                token: response?.authorization?.id_token || '',
                supplier_referral: supplier_referral || null,
              }),
            ).unwrap();
            dispatch(login(data as loginResponse));
          } catch (error: any) {
            toast.error(error?.message || 'Sign-in failed');
          }
        }}
        onError={(error: any) => {
          console.error(error);
          toast.error(error.message);
        }}
        render={({ onClick }: { onClick: () => void }) => (
          <button
            onClick={onClick}
            className="w-full flex items-center justify-center gap-3 p-2 h-10 shadow-sm rounded-md bg-white hover:bg-gray-50 transition-colors border-1 border-primary"
          >
            <AppleLogo />
            <span className="text-sm font-medium text-gray-700">Apple</span>
          </button>
        )}
      />
    </div>
  );
};

export default AppleAuthComponent;
